/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { FirmSearchRequest } from '../models';
import { LinkedPracticeViewResponse } from '../models';
import { PracticeAdditionalContactViewResponse } from '../models';
import { PracticeViewResponse } from '../models';
import { SearchPracticeViewIEnumerableResponse } from '../models';
/**
 * PracticeApi - axios parameter creator
 * @export
 */
export const PracticeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeGetLinkedPracticesPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PracticeGetLinkedPracticesPracticeIdGet.');
            }
            const localVarPath = `/api/v1/Practice/GetLinkedPractices/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeGetPracticeAdditionalContactPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PracticeGetPracticeAdditionalContactPracticeIdGet.');
            }
            const localVarPath = `/api/v1/Practice/GetPracticeAdditionalContact/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeGetPracticeByIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1PracticeGetPracticeByIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/Practice/GetPracticeById/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FirmSearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeSearchPracticePost: async (body?: FirmSearchRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Practice/SearchPractice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticeApi - functional programming interface
 * @export
 */
export const PracticeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PracticeGetLinkedPracticesPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedPracticeViewResponse>> {
            const localVarAxiosArgs = await PracticeApiAxiosParamCreator(configuration).apiV1PracticeGetLinkedPracticesPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PracticeGetPracticeAdditionalContactPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeAdditionalContactViewResponse>> {
            const localVarAxiosArgs = await PracticeApiAxiosParamCreator(configuration).apiV1PracticeGetPracticeAdditionalContactPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PracticeGetPracticeByIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeViewResponse>> {
            const localVarAxiosArgs = await PracticeApiAxiosParamCreator(configuration).apiV1PracticeGetPracticeByIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {FirmSearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PracticeSearchPracticePost(body?: FirmSearchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchPracticeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PracticeApiAxiosParamCreator(configuration).apiV1PracticeSearchPracticePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PracticeApi - factory interface
 * @export
 */
export const PracticeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeGetLinkedPracticesPracticeIdGet(practiceId: number, options?: any): AxiosPromise<LinkedPracticeViewResponse> {
            return PracticeApiFp(configuration).apiV1PracticeGetLinkedPracticesPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeGetPracticeAdditionalContactPracticeIdGet(practiceId: number, options?: any): AxiosPromise<PracticeAdditionalContactViewResponse> {
            return PracticeApiFp(configuration).apiV1PracticeGetPracticeAdditionalContactPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeGetPracticeByIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<PracticeViewResponse> {
            return PracticeApiFp(configuration).apiV1PracticeGetPracticeByIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FirmSearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PracticeSearchPracticePost(body?: FirmSearchRequest, options?: any): AxiosPromise<SearchPracticeViewIEnumerableResponse> {
            return PracticeApiFp(configuration).apiV1PracticeSearchPracticePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticeApi - object-oriented interface
 * @export
 * @class PracticeApi
 * @extends {BaseAPI}
 */
export class PracticeApi extends BaseAPI {
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeApi
     */
    public apiV1PracticeGetLinkedPracticesPracticeIdGet(practiceId: number, options?: any) {
        return PracticeApiFp(this.configuration).apiV1PracticeGetLinkedPracticesPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeApi
     */
    public apiV1PracticeGetPracticeAdditionalContactPracticeIdGet(practiceId: number, options?: any) {
        return PracticeApiFp(this.configuration).apiV1PracticeGetPracticeAdditionalContactPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeApi
     */
    public apiV1PracticeGetPracticeByIdPracticeIdGet(practiceId: number, options?: any) {
        return PracticeApiFp(this.configuration).apiV1PracticeGetPracticeByIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {FirmSearchRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeApi
     */
    public apiV1PracticeSearchPracticePost(body?: FirmSearchRequest, options?: any) {
        return PracticeApiFp(this.configuration).apiV1PracticeSearchPracticePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
